import { Component, OnInit, AfterViewInit, Input, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { PdfViewerService } from 'src/app/services/pdf-viewer.service';

// Read-only "quick look" at a PDF straight from the file explorer's right-click menu - reuses the
// same PdfViewerService (PDF.js wrapper) the e-signature setup page uses to render pages, just
// without any of that page's annotation/editing machinery.
@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.page.html',
  styleUrls: ['./pdf-preview.page.scss'],
})
export class PdfPreviewPage implements OnInit, AfterViewInit {
  @Input() file: any;

  loading = true;
  error_message = '';
  pageNumbers: number[] = [];
  scale = 1.5;

  @ViewChildren('pdfCanvas') pdfCanvases!: QueryList<ElementRef<HTMLCanvasElement>>;

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    public globalService: GlobalService,
    public pdfViewerService: PdfViewerService
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.LoadDocument();
  }

  async LoadDocument() {
    this.loading = true;
    this.error_message = '';
    try {
      let OTC: any = await this.apiService.get('one_time_code');
      OTC = OTC.otc;
      const customHeaders: any = { OTC: OTC };
      const url = this.apiService.GetDownloadURL(this.file);

      await this.pdfViewerService.loadPDF(url, customHeaders);

      this.pageNumbers = [];
      for (let i = 1; i <= this.pdfViewerService.getNumPages(); i++) {
        this.pageNumbers.push(i);
      }
      this.loading = false;

      // Wait for the canvases to exist in the DOM before rendering into them.
      setTimeout(() => this.RenderAllPages(), 100);
    } catch (error) {
      console.error('Error loading PDF preview:', error);
      this.error_message = 'Unable to load a preview of this file.';
      this.loading = false;
    }
  }

  async RenderAllPages() {
    for (const pageNum of this.pageNumbers) {
      await this.RenderPage(pageNum);
    }
  }

  async RenderPage(pageNum: number) {
    const canvas = this.pdfCanvases?.toArray().find(c =>
      c.nativeElement.getAttribute('data-page') === pageNum.toString()
    );
    if (!canvas) return;
    await this.pdfViewerService.renderPage(pageNum, canvas.nativeElement, this.scale);
  }

  ZoomIn() {
    this.scale = Math.min(this.scale + 0.25, 3.0);
    setTimeout(() => this.RenderAllPages());
  }

  ZoomOut() {
    this.scale = Math.max(this.scale - 0.25, 0.5);
    setTimeout(() => this.RenderAllPages());
  }

  ResetZoom() {
    this.scale = 1.5;
    setTimeout(() => this.RenderAllPages());
  }

  Download() {
    this.apiService.DownloadFile(this.file);
  }

  Close() {
    this.modalController.dismiss();
  }
}
